import { getListOfChangedAttributes } from "#src/routes/change-log/ActivityLogsPage.helpers";
import {
  renderRecordValueAttachment,
  renderRecordValueConfigurationType,
  renderRecordValueNote,
  renderRecordValueSource,
  renderRecordValueSourceType,
  renderRecordValueStatus,
} from "#src/utils/recordUtils";
import { KeyValueList } from "@validereinc/common-components";
import {
  RecordValueType,
  Resources,
  type ActivityType,
} from "@validereinc/domain";
import classNames from "classnames/bind";
import { get } from "es-toolkit/compat";
import React, { ReactNode } from "react";
import styles from "./ActivityLogsUpdateDetailsKeyValueList.module.scss";

const cx = classNames.bind(styles);

export const ActivityLogsUpdateDetailsKeyValueList = ({
  selectedLog,
}: {
  selectedLog: ActivityType | null;
}) => {
  if (!selectedLog) {
    return null;
  }

  const { before, after } = selectedLog;

  const uniqueChangedAttributes = getListOfChangedAttributes(selectedLog);

  const getKeyValuePerAttribute = (attribute: string) => {
    let getValue: (item: RecordValueType) => ReactNode = (item) =>
      get(item, attribute);

    if (selectedLog.resource_type === Resources.RECORD_VALUE) {
      switch (attribute) {
        case "sources":
          getValue = renderRecordValueSource;
          break;
        case "source_type":
          getValue = renderRecordValueSourceType;
          break;
        case "configuration_type":
          getValue = renderRecordValueConfigurationType;
          break;
        case "attachment":
          getValue = renderRecordValueAttachment;
          break;
        case "status":
          getValue = renderRecordValueStatus;
          break;
        case "note":
          getValue = renderRecordValueNote;
          break;
      }
    }

    const getAttributeValue = (obj?: RecordValueType | null): ReactNode => {
      if (getValue(obj as any) !== undefined) {
        return getValue(obj as any);
      }

      if ((obj as any)?.custom_attributes?.[attribute] !== undefined) {
        if (typeof (obj as any)?.custom_attributes?.[attribute] === "object") {
          return JSON.stringify((obj as any).custom_attributes[attribute]);
        }
        return (obj as any).custom_attributes[attribute] as ReactNode;
      }

      if ((obj as any)?.attributes?.[attribute] !== undefined) {
        if (typeof (obj as any).attributes[attribute] === "object") {
          return JSON.stringify((obj as any).attributes[attribute]);
        }
        return (obj as any).attributes[attribute] as ReactNode;
      }

      if (obj?.configuration?.[attribute] !== undefined) {
        if (typeof obj.configuration[attribute] === "object") {
          return JSON.stringify(obj.configuration[attribute]);
        }
        return obj.configuration[attribute] as ReactNode;
      }

      return null;
    };

    const previousValue = getAttributeValue(before as any);
    const updatedValue = getAttributeValue(after as any);

    return [
      {
        title: "Previous Value",
        value: previousValue,
      },
      {
        title: "Updated Value",
        value: updatedValue,
      },
    ];
  };

  return (
    <>
      {uniqueChangedAttributes?.map((attribute) => {
        return (
          <>
            <h1 className={cx("title")}>{attribute}</h1>
            <KeyValueList
              data={getKeyValuePerAttribute(attribute)}
              className={cx("keyValueListContainer")}
            />
          </>
        );
      })}
    </>
  );
};
